import React, { FunctionComponent } from 'react';

import { CoverLayer as CoverLayerBase } from '@ps-int/cover-layer';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { getCover, getThemeSettings } from '../../features/config/selectors';
import classes from './index.css';

interface CoverLayerProps {
    isAbsolute?: boolean;
}

const CoverLayer: FunctionComponent<CoverLayerProps> = ({ isAbsolute }) => {
    const themeSettings = useSelector(getThemeSettings);
    const cover = useSelector(getCover);

    if (!cover) {
        return null;
    }

    const { imageUrl, videoUrl } = cover;

    const props = {
        imageUrl,
        ...(themeSettings?.isVideoEnabled ? { videoUrl } : {}),
    };

    return (
        <CoverLayerBase className={cn(classes.CoverLayer, { [classes.CoverLayer_absolute]: isAbsolute })} {...props} />
    );
};

export default CoverLayer;
